module.exports = __webpack_public_path__ + "static/media/mercosul-flag.3611b4f2.png";